var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "fade", appear: "" },
      on: { "after-enter": _vm.afterEnter }
    },
    [
      _c(
        "div",
        { staticClass: "overlay fixed top-left bottom-right zi-1000" },
        [
          _c(
            "transition",
            { attrs: { name: "slide" }, on: { "after-leave": _vm.close } },
            [
              _vm.slideContent
                ? _c(
                    "div",
                    {
                      staticClass:
                        "fixed top-right white-bkg shadow bottom-0 flex flex-column",
                      class: " sidepanel-" + _vm.size
                    },
                    [
                      _c("preloader", { attrs: { display: _vm.loading } }),
                      _vm._v(" "),
                      _c(
                        "header",
                        { staticClass: "pl-3 pr-7 py-4 white dark-blue-bkg" },
                        [
                          _vm._t("header"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "white absolute top-4 right-3",
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  _vm.slideContent = false
                                }
                              }
                            },
                            [_c("i", { staticClass: "icon-close icon-16" })]
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "p-3 flex-fill-column side-panel-content"
                        },
                        [_vm._t("content")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.hasFooter
                        ? _c(
                            "div",
                            { staticClass: "px-3 py-5 aright bt-1" },
                            [_vm._t("footer")],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }